import React, { useState, useEffect } from "react";
import "../../../styles/utils/modal/BackgroundModal.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

const BackgroundModal = ({
  modalTitle,
  propImg = [],
  originImg,
  onImageSelect,
  onRegenerate,
  onClose,
}) => {
  const { t } = useAppTranslation("components/utils/backgroundModal");
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(true);
  // const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    setIsButtonDisabled(selectedImage === null);
  }, [selectedImage]);

  const selectImage = (image) => {
    if (selectedImage === image) {
      setSelectedImage(null);
    } else {
      setSelectedImage(image);
    }
  };

  const handleChangeButtonClick = () => {
    console.log("ChangeButton Clicked!");
    onImageSelect(selectedImage);
    setIsModalOpen(false);
  };

  const handleRegenerateButtonClick = () => {
    console.log("RegenerateButton Clicked!");
    onRegenerate();
  };

  return (
    <div>
      <section className="image-modal-section">
        <figure className="close-modal-btn" onClick={onClose}>
          <img src={"/images/utils/close.png"} alt={t("actions.close")} />
        </figure>
        <div className="modal-container">
          <h3 className="modal-title">{modalTitle || t("title")}</h3>
          <div className="ai-image-container">
            <div
              className="ai-image-box"
              onClick={() => selectImage(originImg)}
            >
              <div className="origin-text origin">
                {t("labels.originalBackground")}
                <div className="text-stroke origin">
                  {t("labels.originalBackground")}
                </div>
              </div>
              <figure
                className={`ai-image ${
                  selectedImage === originImg ? "selected" : ""
                }`}
              >
                <img src={originImg} alt={t("alts.originalBackground")} />
              </figure>
            </div>
            <div
              className="ai-image-box"
              onClick={() => selectImage(propImg[0])}
            >
              <div className="origin-text new">
                {t("labels.newBackground")}
                <div className="text-stroke new">
                  {t("labels.newBackground")}
                </div>
              </div>
              <figure
                className={`ai-image ${
                  selectedImage === propImg[0] ? "selected" : ""
                }`}
              >
                <img src={propImg[0]} alt={t("alts.newBackground")} />
              </figure>
            </div>
          </div>
          <div className="choose-btn-container">
            <button
              className="class-btns re-make"
              onClick={handleRegenerateButtonClick}
            >
              {t("actions.regenerateImage")}
            </button>
            <button
              className={`class-btns confirm-image ${
                isButtonDisabled ? "disabled" : ""
              }`}
              onClick={handleChangeButtonClick}
              disabled={isButtonDisabled}
            >
              {t("actions.select")}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BackgroundModal;
